import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandLink from "../../../components/BrandLink";
import { ReadableNavButton } from "../../../components/Sticker";
import {
  FD_HOW_IT_WORKS_FEED,
  FD_HOW_IT_WORKS_PICKS,
  FD_HOW_IT_WORKS_PLAY,
  FD_HOW_IT_WORKS_TITLE,
} from "../copy.js";

const PARAGRAPHS = [FD_HOW_IT_WORKS_PLAY, FD_HOW_IT_WORKS_PICKS, FD_HOW_IT_WORKS_FEED];

export default function HowItWorksPage() {
  return (
    <div className="max-w-page mx-auto px-4 py-8 sm:py-12">
      <ReadableNavButton
        as={Link}
        to="/events"
        className="inline-flex items-center gap-1.5 mb-6 text-[14px]"
      >
        <ArrowLeft className="w-4 h-4" strokeWidth={2.5} aria-hidden />
        Back to events
      </ReadableNavButton>

      <header className="mb-8">
        <BrandLink className="mb-4 inline-block" />
        <h1 className="font-display font-bold text-[28px] sm:text-[32px] text-ink text-balance">
          {FD_HOW_IT_WORKS_TITLE}
        </h1>
      </header>

      <div className="space-y-6 max-w-[60ch]">
        {PARAGRAPHS.map((text) => (
          <p key={text} className="font-ui text-[16px] leading-relaxed text-ink/80 text-pretty">
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}
